import dynamic from 'next/dynamic'
import React from 'react'

const ReactPlayerDynamic = dynamic(() => import('react-player/youtube'), {
  ssr: false
})

const ApproachSection = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:max-w-screen-2xl lg:px-8 space-y-24 py-12 w-full">
      <div className="flex flex-col md:flex-row items-center justify-between gap-y-4">
        <div className="w-full space-y-3">
          <h3 className="text-3xl font-medium">Devsnest Tech School</h3>
          <p className="text-gray-700 text-base md:text-lg lg:text-xl">
            Introducing Devsnest Tech school,
          </p>
          <p className="text-gray-700 text-base md:text-lg lg:text-xl">
            See our Devsnest Founder{' '}
            <span className="underline text-decoration-primary underline-offset-2">
              Vedansh
            </span>{' '}
            Sharing details about the programme in this video
          </p>
        </div>

        <div className="block w-full md:w-fit">
          <div className="w-full h-[320px] md:w-[550px] border-2 border-gray-300 rounded-2xl">
            <ReactPlayerDynamic
              url="https://youtu.be/bxn6QwwbRQs"
              height="100%"
              width="100%"
              controls
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ApproachSection
